module.exports = __webpack_public_path__ + "295ad1766eb12c33240196f168862237.png";